import { render, staticRenderFns } from "./TitleButton.vue?vue&type=template&id=d58f383a&scoped=true"
import script from "./TitleButton.ts?vue&type=script&lang=ts&external"
export * from "./TitleButton.ts?vue&type=script&lang=ts&external"
import style0 from "./TitleButton.scss?vue&type=style&index=0&id=d58f383a&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58f383a",
  null
  
)

export default component.exports